export default "__VITE_ASSET__1gBQX15i__"